"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInTranslations = void 0;
const sheet_db_1 = require("../sheet_db");
const getInTranslations = () => {
    const inTranslations = {};
    Object.entries(sheet_db_1.OutFormulaTranslations).forEach(([language, translations]) => {
        const organizedTranslations = {
            formulas: {},
            global: { booleans: {} },
        };
        // invert alias, date formats and enum replacements (to convert formula to our frontend)
        Object.entries(translations.formulas).forEach(([key, value]) => {
            const translatedFunction = JSON.parse(JSON.stringify(value));
            organizedTranslations.formulas[translatedFunction.alias] = translatedFunction;
            translatedFunction.alias = key;
            invertDateFormats(translatedFunction);
            invertEnumReplacements(translatedFunction);
        });
        Object.entries(translations.global.booleans).forEach(([key, value]) => (organizedTranslations.global.booleans[value] = key));
        inTranslations[language] = organizedTranslations;
    });
    return inTranslations;
};
exports.getInTranslations = getInTranslations;
const invertDateFormats = (translatedFunction) => {
    const newSourceDateFormat = translatedFunction.target_date_format;
    translatedFunction.target_date_format = translatedFunction.source_date_format;
    translatedFunction.source_date_format = newSourceDateFormat;
};
const invertEnumReplacements = (translatedFunction) => {
    translatedFunction.replacements = translatedFunction.replacements?.map(replace => {
        if (!replace)
            return replace;
        const translatedReplace = {};
        Object.entries(replace).forEach(([k, v]) => {
            translatedReplace[v] = k;
        });
        return translatedReplace;
    });
};
